module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bNFoS"))).then(() => parcelRequire('1iHdE'));